import { withInstall } from '@ll-plus/utils'

import ColumnManager from './src/column-manager.vue'

export const LlColumnManager = withInstall(ColumnManager)
export default LlColumnManager
export * from './src/column-manager'

declare module 'vue' {
  export interface GlobalComponents {
    LlColumnManager: typeof ColumnManager
  }
}
